import * as React from 'react';
import { AddOverlay } from 'components/ContainerTable';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'constants/pages';

export const AddShipmentsOverlay: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AddOverlay
      variant="shipment"
      openAddModal={() => navigate(Routes.ShipmentsAdd)}
      className="pt-8"
    />
  );
};
AddShipmentsOverlay.displayName = 'Containers.AddShipmentsOverlay';
